export const Quiz = `
<h3>Quiz</h3>
<hr />
<article id="quiz">
   <div class="row">
      <div class="col-xl-3 col-lg-3 d-none d-lg-block"></div>
      <div class="col-xl-7 col-lg-7 col-md-12 col-sm-12 justify-content-center">
         <div class="intro-copy">As someone with ENFJ preferences, you may find that the following actions or behaviors drain your confidence. Pick one and click <span class="semibold-text">Submit</span> to see the answer.</div>
         <div class="radiobutton-list">
            <div class="radio-container" id="radio1-container">
               <input type="radio" id="radio1" value="1" name="quiz-radio">
               <label for="radio1" class="radio-label" id="radio1-label">Receiving insufficient feedback on and appreciation for your contribution</label>
            </div>
            <div class="radio-container" id="radio2-container">
               <input type="radio" id="radio2" value="2" name="quiz-radio">
               <label for="radio2" class="radio-label" id="radio2-label">Working in a competitive environment that lacks harmony</label>
            </div>
            <div class="radio-container" id="radio3-container">
               <input type="radio" id="radio3" value="3" name="quiz-radio">
               <label for="radio3" class="radio-label" id="radio3-label">Finding flaws in others’ ideas and correcting them</label>
            </div>
            <div class="radio-container" id="radio4-container">
               <input type="radio" id="radio4" value="4" name="quiz-radio">
               <label for="radio4" class="radio-label" id="radio4-label">Working in a situation where expectations and outcomes are unclear</label>
            </div>
            <div class="radio-container" id="radio5-container">
               <input type="radio" id="radio5" value="5" name="quiz-radio">
               <label for="radio5" class="radio-label" id="radio5-label"></label>
            </div>
            <div class="radio-container" id="radio6-container">
               <input type="radio" id="radio6" value="6" name="quiz-radio">
               <label for="radio6" class="radio-label" id="radio6-label"></label>
            </div>
         </div>
         <div class="col-xl-2 col-lg-2 d-none d-lg-block"></div>
      </div>
   </div>
   <div class="row">
      <div class="col-xl-3 col-lg-3 d-none d-lg-block">
         <input type="hidden" value="2" id="quizanswer" />
      </div>
      <div class="col-xl-7 col-lg-7 col-md-12 col-sm-12 justify-content-center">
         <div class="submit-quiz" id="submit-quiz"><button class="btn-outline-secondary" onclick="quizAnswerCheck()">Submit</button></div>
         <div class="d-none" id="quiz-success-text">
            <div class="d-flex success-text justify-content-center">
               <div class="success-image"><img src="assets/images/icons/green-tickmark.svg" /></div>
               <div id="success"></div>
            </div>
         </div>
         <div class="d-none error-text" id="quiz-error-text">
            <div id="error"></div>
         </div>
      </div>
      <div id="feedback1" style="display: none">I'm sorry, answer 1 is <b>not</b> correct</div>
      <div id="feedback2" style="display: none">Congratulations, answer 2 <u>is</u> correct. <a href="http://themyersbriggs.com">Link</a></div>
      <div id="feedback3" style="display: none">I'm sorry, answer 3 is <b>not</b> correct</div>
      <div id="feedback4" style="display: none">I'm sorry, answer 4 is <b>not</b> correct</div>
      <div id="feedback5" style="display: none"></div>
      <div id="feedback6" style="display: none"></div>
      <div class="col-xl-2 col-lg-2 d-none d-lg-block"></div>
   </div>
</article>
`;
